"use strict";
exports.__esModule = true;
exports.SLC_HOW_FLEX_WORKS_CONTENT = void 0;
var FLEX_CLASSIC_BULLETS = [
    {
        HEADER: 'Deposit {{deposit}} to get started',
        BODY: 'Your refundable deposit unlocks your Flex credit line.'
    },
    {
        HEADER: 'Flex pays your {{rentAmount}} rent',
        BODY: 'Your rent is paid directly to your property when it’s due. '
    },
    {
        HEADER: 'Pay Flex back in two payments',
        BODY: 'We’ll help you choose your monthly payment schedule in the next steps.'
    },
    {
        HEADER: 'Repeat whenever!',
        BODY: 'Enjoy flexible rent when you need it.'
    },
];
var FLEX_ANYWHERE_BULLETS = [
    {
        HEADER: 'Deposit {{deposit}} to get started',
        BODY: 'Your refundable deposit unlocks your Flex credit line.'
    },
    {
        HEADER: 'Flex then helps you pay your {{rentAmount}} rent',
        BODY: 'We then pay your full rent directly to your property when it’s due.'
    },
    {
        HEADER: 'You then pay flex back',
        BODY: 'We’ll help you choose your monthly payment schedule.'
    },
];
exports.SLC_HOW_FLEX_WORKS_CONTENT = {
    HEADER: 'How to split your rent',
    CTA: 'Continue',
    FLEX_CLASSIC_BULLETS: FLEX_CLASSIC_BULLETS,
    FLEX_ANYWHERE_BULLETS: FLEX_ANYWHERE_BULLETS
};
